/* ========================================================================
 * Maps
 * ======================================================================== */

/* global google, storeMapIconUrl, googleMapsApiKey */

//import GeoHelper from "./geohelper";


//storeMapIconUrl set in Document header in Stage



//window.maps = [];

//Initiate all Google Maps on the page
function initMap(maps) {

	if (typeof maps === "undefined") {
		maps = document.querySelectorAll(".google-map[data-location]");
	}

	for (const map of maps) {

		//https://maps.googleapis.com/maps/api/staticmap?center=Brooklyn+Bridge,New+York,NY&zoom=13&size=600x300&maptype=roadmap&markers=color:blue%7Clabel:S%7C40.702147,-74.015794&markers=color:green%7Clabel:G%7C40.711614,-74.012318&markers=color:red%7Clabel:C%7C40.718217,-73.998284&key=AIzaSyDRJ42UJXXqGw9-JgpZ2srGbF59tSqGXhQ


		//const directionsService = new google.maps.DirectionsService;
		//const directionsDisplay = new google.maps.DirectionsRenderer;

		const latitude = map.dataset.latitude;
		const longitude = map.dataset.longitude;
		const location = map.dataset.location;


		if (latitude && longitude) {
			//Coordinates exist, show map

			const urlParams = [
				{
					key: "markers",
					value: "anchor:17,44|icon:https:" + storeMapIconUrl + "|" + latitude + "," + longitude
				},
				{
					key: "size",
					value: "640x450"
				},
				{
					key: "zoom",
					value: "15"
				},
				{
					key: "key",
					value: googleMapsApiKey
				}
			];

			const mapsLink = document.createElement("a");
			mapsLink.href = "https://www.google.com/maps/search/?api=1&query=" + (location ? location : latitude + "," + longitude);
			mapsLink.target = "_blank";
			mapsLink.title = location ? "Näytä myymälän " + decodeURIComponent(location) + " sijainti Google Mapsissa." : "Näytä myymälän sijainti Google Mapsissa.";
			mapsLink.classList.add("maps-link");
			const mapImage = document.createElement("img");
			mapImage.classList.add("lazyload");
			mapImage.dataset.src = "https://maps.googleapis.com/maps/api/staticmap?" + urlParams.map(param => {
				return encodeURIComponent(param.key) + "=" + encodeURIComponent(param.value);
			}).join("&");
			mapImage.width = "640";
			mapImage.height = "450";
			mapsLink.appendChild(mapImage);

			map.appendChild(mapsLink);

			/*
			const storePosition = {
				lat: parseFloat(latitude),
				lng: parseFloat(longitude)
			};

			const gmap = new google.maps.Map(map, {
				center: storePosition,
				zoom: 15
			});

			gmap.setOptions({
				gestureHandling: "cooperative"
			});

			directionsDisplay.setMap(gmap);


			new google.maps.Marker({
				map: gmap,
				position: storePosition,
				icon: {
					url: storeMapIconUrl, //This is set in Stage (Document header)
					size: new google.maps.Size(89, 44),
					scaledSize: new google.maps.Size(89, 44),
					anchor: new google.maps.Point(17, 44)
				}
			});
*/

			/*
			const routeDriving = map.querySelector(".store-route-driving");
			if (routeDriving) {
				routeDriving.addEventListener("click", (e) => {
					e.preventDefault();
					routeHandler("DRIVING", storePosition, directionsService, directionsDisplay);
				});
			}

			const routeTransit = map.querySelector(".store-route-transit");
			if (routeTransit) {
				routeTransit.addEventListener("click", (e) => {
					e.preventDefault();
					routeHandler("TRANSIT", storePosition, directionsService, directionsDisplay);
				});
			} */

		}

	}
}

/*
function routeHandler(travelMode, storePosition, directionsService, directionsDisplay) {

	GeoHelper.locateMe(function (pos) {

		var route = {
			origin: { lat: pos.coords.latitude, lng: pos.coords.longitude },
			destination: storePosition,
			travelMode: travelMode
		};

		calculateAndDisplayRoute(directionsService, directionsDisplay, route);

	}, function (err) {

		// eslint-disable-next-line no-alert
		alert(err.message);
		console.log(err);

	});

} 
function calculateAndDisplayRoute(directionsService, directionsDisplay, route) {
	directionsService.route(route, function (response, status) {
		//console.log(response, status);
		if (status === "OK") {
			directionsDisplay.setDirections(response);
		} else {
			// eslint-disable-next-line no-alert
			//alert("Directions request failed due to " + status);
			// Fail silently.
		}
	});
} */


export default initMap;